import { $, _ } from './el.JsModules.js';

elabs.Bootstrap = class {
  'use strict';

  constructor() {
    elabs.windowElement = $(window);
    elabs.documentElement = $(document);
    elabs.bodyElement = $('body');

    this.latestKnownScrollY = 0;
    this.ticking = false;

    //AOS.init();
    // We need to refresh once or twice to make 100% sure it has calculated correctly
    //setTimeout(AOS.refresh, 2000);
    //setTimeout(AOS.refresh, 5000);

    elabs.MouseCursor.init();

    elabs.javascriptIsReady();

    this.initialiseScrollEvent();
    this.initialiseResizeEvent();
    elabs.Bootstrap.initialiseTooltips();
    this.initialiseLiveChatAutoHide();
    this.showWelcomeBackToast();
    this.showTradeLoginPromptToast();
    this.initialiseImageProtection();
    setTimeout(() => {
      this.initialiseEcologiTreeCount();
    }, 1800);

    //setTimeout(() => {
    //$('.el-header__secondary-nav-link--cart').click();
    //}, 200);

    if (typeof window.console !== 'undefined') {
      const nowDate = new Date();
      window.console.log(
        '****************************       \nsite by Electric Labs ' +
          nowDate.getFullYear() +
          '\n****************************       \n www.electriclabs.com \n****************************       ',
      );
      window.console.log('');
    }
  }

  initialiseScrollEvent() {
    const updateAfterScrollOnAnimFrame = () => {
      this.ticking = false;
      $.event.trigger('WINDOW_SCROLL_EVENT', [this.latestKnownScrollY]);
    };

    const requestTick = () => {
      if (!this.ticking) {
        requestAnimationFrame(updateAfterScrollOnAnimFrame);
      }
      this.ticking = true;
    };

    window.addEventListener(
      'scroll',
      () => {
        this.latestKnownScrollY = window.scrollY || window.pageYOffset;
        requestTick();
      },
      false,
    );
  }

  initialiseResizeEvent() {
    let windowResizeAnimFrameRequested = false;
    elabs.windowElement.resize(
      _.debounce(() => {
        if (!windowResizeAnimFrameRequested) {
          windowResizeAnimFrameRequested = true;
          requestAnimationFrame(() => {
            windowResizeAnimFrameRequested = false;
            $.event.trigger('WINDOW_RESIZED_EVENT', [elabs.windowElement.width(), elabs.windowElement.height()]);
          });
        }
      }, 1000),
    );
  }

  static initialiseTooltips(selector = '[data-tippy-content]') {
    $(selector).each(function () {
      const $element = $(this);
      const isPositionFixed = $element.attr('data-tippy-positionfixed') === 'true';
      const triggerTarget = $element.attr('data-tippy-trigger-target');
      let triggerTargetClosest;
      if (!triggerTarget) {
        triggerTargetClosest = $element.attr('data-tippy-trigger-target-closest');
      }
      const showOnCreate = $element.attr('data-tippy-show-on-create') === 'true'; // show it as soon as it is initialised
      const bounceDownwards = $element.attr('data-tippy-bounce-downwards') === 'true';
      const bounceUpwards = $element.attr('data-tippy-bounce-upwards') === 'true';
      const appendTo = $element.attr('data-tippy-append-to') === 'parent' ? 'parent' : document.body;
      const maxWidth = +$element.attr('data-tippy-max-width') || 350;
      const disappearDelay = parseInt($element.attr('data-tippy-disappear-delay'));
      const shouldNotHideOnClick = $element.attr('data-tippy-hide-on-click') === 'false';

      tippy(this, {
        theme: 'onedotworld',
        animation: 'shift-toward',
        showOnCreate: showOnCreate,
        appendTo,
        maxWidth,
        interactiveBorder: 30,
        ...(shouldNotHideOnClick && { hideOnClick: false }), // do not hide on click
        ...(disappearDelay && { delay: [null, disappearDelay] }), // delay the disappearance of the tooltip
        // delay: [null, 100000], // for debugging (delays the disappearance of the tooltip)
        onShow(instance) {
          if (bounceUpwards) {
            instance.popper.firstElementChild.classList.add('bouncing-upwards');
          } else if (bounceDownwards) {
            instance.popper.firstElementChild.classList.add('bouncing-downwards');
          }
        },
        ...(triggerTarget && { triggerTarget: document.querySelector(triggerTarget) }),
        ...(triggerTargetClosest && { triggerTarget: this.closest(triggerTargetClosest) }),
        ...(isPositionFixed && {
          popperOptions: {
            strategy: 'fixed', // this prevents it flickering on scroll
          },
        }),
      });
    });
  }

  initialiseLiveChatAutoHide() {
    if (elabs.windowElement.width() >= 1150) {
      let isLiveChatHidden = false;
      const liveChatElement = $('.el-live-chat');
      elabs.documentElement.on('WINDOW_SCROLL_EVENT', (evt, scrollY) => {
        let scrollPosition = scrollY + elabs.windowElement.height();
        let documentHeight = elabs.documentElement.height();
        let threshold = 50; // Distance from bottom

        const shouldHide = documentHeight - scrollPosition <= threshold;
        if (!isLiveChatHidden && shouldHide) {
          isLiveChatHidden = true;
          liveChatElement.addClass('el-live-chat--hidden');
          // Call your function here
        }

        if (isLiveChatHidden && !shouldHide) {
          isLiveChatHidden = false;
          liveChatElement.removeClass('el-live-chat--hidden');
        }
      });
    }
  }

  showWelcomeBackToast() {
    if (!window.elStrings.welcomeBackToastMessage) {
      return; // No message to show
    }

    let lastShownToastDate = localStorage.getItem('el-customer-last-shown-welcome-back-toast-timestamp');
    if (lastShownToastDate) {
      lastShownToastDate = parseInt(lastShownToastDate);
      lastShownToastDate = new Date(lastShownToastDate);

      const now = new Date().getTime();
      //const seventyTwoHoursAfterLastShownNewsletterOverlay = lastShownToastDate.getTime() + 10 * 1000; // 10 seconds (for testing)
      const seventyTwoHoursAfterLastShownNewsletterOverlay = lastShownToastDate.getTime() + 72 * 60 * 60 * 1000; // 72 hours between showing the welcome back overlay again

      if (now < seventyTwoHoursAfterLastShownNewsletterOverlay) {
        return false; // We do not want to show the toast for now
      }
    }

    requestTimeout(() => {
      elabs.Utils.showToast(window.elStrings.welcomeBackToastMessage, undefined, 9000);
      requestTimeout(() => {
        localStorage.setItem('el-customer-last-shown-welcome-back-toast-timestamp', new Date().getTime());
      }, 5000);
    }, 500);
  }

  showTradeLoginPromptToast() {
    if (window.customer.is_trade_customer) {
      localStorage.setItem('el-has-previously-logged-in-as-trade', 'true');
      localStorage.setItem('el-last-shown-trade-login-prompt-timestamp', new Date().getTime()); // (to make sure they don't see it the moment they log out)
    }

    if (window.customer.is_trade_customer) {
      return; // No message to show
    }

    if (localStorage.getItem('el-has-previously-logged-in-as-trade') !== 'true') {
      return; // No message to show
    }

    let lastShownToastDate = localStorage.getItem('el-last-shown-trade-login-prompt-timestamp');
    if (lastShownToastDate) {
      lastShownToastDate = parseInt(lastShownToastDate);
      lastShownToastDate = new Date(lastShownToastDate);

      const now = new Date().getTime();
      // const seventyTwoHoursAfterLastShownNewsletterOverlay = lastShownToastDate.getTime() + 10 * 1000; // 10 seconds (for testing)
      const seventyTwoHoursAfterLastShownNewsletterOverlay = lastShownToastDate.getTime() + 24 * 60 * 60 * 1000; // 24 hours between showing the trade prompt login toast again

      if (now < seventyTwoHoursAfterLastShownNewsletterOverlay) {
        return false; // We do not want to show the toast for now
      }
    }

    requestTimeout(() => {
      elabs.Utils.showToast('Log in to unlock Trade Customer pricing', undefined, 8000);
      requestTimeout(() => {
        localStorage.setItem('el-last-shown-trade-login-prompt-timestamp', new Date().getTime());
      }, 5000);
    }, 500);
  }

  initialiseImageProtection() {
    // Prevent images from being downloaded
    // Note, we COULD be a bit more prescriptive and only do this on certain product images, but this is a good start
    $('body').on('contextmenu', '.el-image-download-protection', function (e) {
      e.preventDefault();
      console.log('EL Right-click is disabled on this image.');
    });

    // Prevent long press on specific images (on mobile)
    let longPressTimer;
    $('body').on('touchstart', '.el-image-download-protection', function (e) {
      longPressTimer = setTimeout(() => {
        e.preventDefault();
        console.log('EL Long press is disabled on this image.');
      }, 500); // Adjust delay for long press (500ms is typical)
    });

    $('body').on('touchend touchmove', '.el-image-download-protection', function () {
      clearTimeout(longPressTimer); // Cancel long press if touch ends or moves
    });
  }

  initialiseEcologiTreeCount() {
    let hasReplacedTreeCount = false;
    const cachedTreeCount = localStorage.getItem('el-tree-count');
    if (cachedTreeCount) {
      this.replaceTreeCount(cachedTreeCount);
      hasReplacedTreeCount = true;
    }

    let lastCheckedTreeCountDate = localStorage.getItem('el-last-checked-tree-count-timestamp');
    if (cachedTreeCount && lastCheckedTreeCountDate) {
      lastCheckedTreeCountDate = parseInt(lastCheckedTreeCountDate);
      lastCheckedTreeCountDate = new Date(lastCheckedTreeCountDate);

      var now = new Date().getTime();
      var hundredTwentyMinutesAfterLastCheck = lastCheckedTreeCountDate.getTime() + 120 * 60 * 1000; // 120 minutes, 2 hours
      if (now < hundredTwentyMinutesAfterLastCheck) {
        return; // We fetched this recently, do not fetch again, just use the cached value
      }
    }

    // Fetch the tree count from Ecologi
    fetch('https://public.ecologi.com/users/onedotworld/trees')
      .then((res) => res.json())
      .then((data) => {
        const totalTrees = data.total;
        if (!data || Number.isInteger(totalTrees) === false) {
          console.error('Invalid data received from Ecologi:', data);
          return;
        }
        const formattedTotalTrees = totalTrees.toLocaleString('en-GB');
        if (!hasReplacedTreeCount) {
          this.replaceTreeCount(formattedTotalTrees);
        }

        localStorage.setItem('el-tree-count', formattedTotalTrees);
        localStorage.setItem('el-last-checked-tree-count-timestamp', new Date().getTime());
      });
  }

  // this is quite expensive, use sparingly
  replaceTreeCount(treeCountString, selector = 'body') {
    const root = typeof selector === 'string' ? document.querySelector(selector) : selector;

    if (!root) {
      console.warn(`replaceTreeCount: No element found for selector "${selector}"`);
      return;
    }

    if (!root.textContent.includes('##ecologi')) {
      return; // No Ecologi tree counts in the selected area
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.includes('##ecologi')) {
        node.nodeValue = node.nodeValue.replace(/##ecologi/g, treeCountString);
      }
    }
  }
};

$(function () {
  // domReady

  // Global uncaught error handling. Sent to GA.
  //if(typeof(window.onerror) !== "undefined") {
  //window.onerror = function(msg, url, line, col, error) {
  //el.Logger.log(true, "Uncaught Error: " + msg + ". \n\nLine number:" + line + ". \n\nURL:" + url + ". \n\nLine number:" + line + ". \n\nColumn number:" + col + ". \n\nError: " + error, false)
  //};
  //}
  new elabs.Bootstrap();
});
